// options module
export const SET_ENABLE_REALTIME = 'SET_ENABLE_REALTIME';
export const SET_USER_REALTIME_PREFERENCE = 'SET_USER_REALTIME_PREFERENCE';

// iserver
export const ISERVER_AUTHENTICATED = 'ISERVER_AUTHENTICATED';
export const CURRENCY_PAIRS = 'CURRENCY_PAIRS';
export const CCY_CHART_PAIR = 'CCY_CHART_PAIR';
export const SET_WATCHLISTMAP = 'SET_WATCHLISTMAP';


// iserverData
export const SET_ISERVER_ACCOUNTS = 'SET_ISERVER_ACCOUNTS';
export const SET_ISERVER_GROUPS = 'SET_ISERVER_GROUPS';
export const SET_ISERVER_PROFILES = 'SET_ISERVER_PROFILES';
export const SET_ISERVER_INFO = 'SET_ISERVER_INFO';
export const SET_UPNL = 'SET_UPNL';
export const SET_ORDERS = 'SET_ORDERS';
export const SET_BULLETINS = 'SET_BULLETINS';
export const MARK_BULLETINS_AS_READ = 'MARK_BULLETINS_AS_READ';
export const SET_AUTH_STATUS = 'SET_AUTH_STATUS';
export const SET_MASTER_ID = 'SET_MASTER_ID';
export const SET_MARKET_DATA = 'SET_MARKET_DATA';
export const SET_COMPETE = 'SET_COMPETE';
export const SET_ISERVER_SSODH = 'SET_ISERVER_SSODH';
export const SET_BRIEFING_ARTICLE = 'SET_BRIEFING_ARTICLE';
export const SET_SELECTED_ACCOUNT = 'SET_SELECTED_ACCOUNT';
export const SET_CHART_PERIODS = 'SET_CHART_PERIODS';
export const SET_ACCOUNT_ALIASES = 'SET_ACCOUNT_ALIASES';
export const CLEAR_ISERVER_DATA = 'CLEAR_ISERVER_DATA';
export const SET_ALLOW_FEATURES = 'SET_ALLOW_FEATURES';
export const SET_LINKS = 'SET_LINKS';
export const SET_ISERVER_ACCOUNT_PROPS = 'SET_ISERVER_ACCOUNT_PROPS';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SET_CONTRACT_INFO = 'SET_CONTRACT_INFO';
export const SET_TRADES = 'SET_TRADES';
export const SET_ISERVER_LOGGING_IN_STATUS = 'SET_ISERVER_LOGGING_IN_STATUS';
export const SET_AVAILABLE_ALERTS = 'SET_AVAILABLE_ALERTS';
export const SET_PRICE_ALERTS = 'SET_PRICE_ALERTS';
export const SET_PRICE_ALERTS_DELIVERY_OPTIONS = 'SET_PRICE_ALERTS_DELIVERY_OPTIONS';
export const SET_MTA_ALERTS = 'SET_MTA_ALERTS';
export const SET_USER_TIMEZONE = 'SET_USER_TIMEZONE';
export const SET_ISERVER_LOGIN_INFO = 'SET_ISERVER_LOGIN_INFO';
export const ISERVER_LOGIN_START_TIME = 'ISERVER_LOGIN_START_TIME';

// events
export const REGISTER_EVENT = 'REGISTER_EVENT';
export const TRIGGER_EVENT = 'TRIGGER_EVENT';

export const SET_SSO_VALIDATED = 'SET_SSO_VALIDATED';

//ibcust
export const SET_MARKETDATA_SUBSCRIPTIONS = 'SET_MARKETDATA_SUBSCRIPTIONS';
export const SET_ENTITY_INFO = 'SET_ENTITY_INFO';
export const SET_ACCOUNT_STATUS = 'SET_ACCOUNT_STATUS';

//dev only
export const SET_CLEARING_STATUS = 'SET_CLEARING_STATUS';
export const SET_FIRST_APPROVE_DATE = 'SET_FIRST_APPROVE_DATE';
export const SET_OPEN_DATE = 'SET_OPEN_DATE';
export const TOGGLE_FREE_TRIAL = 'TOGGLE_FREE_TRIAL';
export const TOGGLE_IS_FUNDED = 'TOGGLE_IS_FUNDED';
export const TOGGLE_SF_ENABLED = 'TOGGLE_SF_ENABLED';
export const SET_WHITE_BRANDING = 'SET_WHITE_BRANDING';

//ia
export const SET_ADVISORS_PROMODATA = 'SET_ADVISORS_PROMODATA';
export const SET_CREATED_PARTITION = 'SET_CREATED_PARTITION';
export const FINISH_IA_PROMO_LOADING = 'FINISH_IA_PROMO_LOADING';

//md farm
export const SET_MD_AUTH_STATUS = 'SET_MD_AUTH_STATUS';

// main module
export const SET_AB_FEATURES = 'SET_AB_FEATURES';
export const SET_AUTH_TOKEN_CREATED = 'SET_AUTH_TOKEN_CREATED';
export const SET_BRAND_INFO = 'SET_BRAND_INFO';
export const SET_EVENT_LISTENERS = 'SET_EVENT_LISTENERS';
export const CLEAR_BALANCE_SUMMARY = 'CLEAR_BALANCE_SUMMARY';
export const CLEAR_OPTION_COMBO = 'CLEAR_OPTION_COMBO';
export const CLEAR_DATASHORT = 'CLEAR_DATASHORT';
export const CLEAR_MARKETDATA = 'CLEAR_MARKETDATA';
export const CLEAR_NEWS = 'CLEAR_NEWS';
export const CLEAR_NEWS_CONTENT = 'CLEAR_NEWS_CONTENT';
export const CLEAR_PERFORMANCE = 'CLEAR_PERFORMANCE';
export const CLEAR_POSITIONS = 'CLEAR_POSITIONS';
export const CLEAR_MODELS = 'CLEAR_MODELS';
export const CLEAR_PRICE_HISTORY = 'CLEAR_PRICE_HISTORY';
export const CLEAR_ALLOCATION = 'CLEAR_ALLOCATION';
export const CLEAR_FA_CLIENT = 'CLEAR_FA_CLIENT';
export const UPDATE_POSITIONS = 'UPDATE_POSITIONS';
export const SET_ACCESSIBILITY = 'SET_ACCESSIBILITY';
export const SET_BALANCE_SUMMARY = 'SET_BALANCE_SUMMARY';
export const SET_ALL_ACCOUNTS = 'SET_ALL_ACCOUNTS';
export const SET_SELECTED_ACCOUNTS = 'SET_SELECTED_ACCOUNTS';
export const SET_PERIOD = 'SET_PERIOD';
export const SET_ACCOUNT_PNL = 'SET_ACCOUNT_PNL';
export const SET_COMPETITORS = 'SET_COMPETITORS';
export const SET_FUNDAMENTALS = 'SET_FUNDAMENTALS';
export const SET_MARKETS = 'SET_MARKETS';
export const SET_MODELS = 'SET_MODELS';
export const SET_SECDEF_DATA = 'SET_SECDEF_DATA';
export const SET_MARKETDATA = 'SET_MARKETDATA';
export const SET_MARKET_HISTORY = 'SET_MARKET_HISTORY';
export const SET_NEWS = 'SET_NEWS';
export const SET_NEWS_CONTENT = 'SET_NEWS_CONTENT';
export const SET_PERFORMANCE = 'SET_PERFORMANCE';
export const SET_POSITIONS = 'SET_POSITIONS';
export const SET_POSITIONS_TOTAL_NUM = 'SET_POSITIONS_TOTAL_NUM';
export const SET_PRICE_HISTORY = 'SET_PRICE_HISTORY';
export const SET_RATES = 'SET_RATES';
export const SET_SEARCH_SYM_RESULTS = 'SET_SEARCH_SYM_RESULTS';
export const SET_USER = 'SET_USER';
export const SET_USERNAME = 'SET_USERNAME';
export const SET_SSO  = 'SET_SSO';
export const TOGGLE_NEWS_CONTENT = 'TOGGLE_NEWS_CONTENT';
export const SET_UAR = 'SET_UAR';
export const SET_OPTION_COMBO = 'SET_OPTION_COMBO';
export const SET_FA_CLIENT = 'SET_FA_CLIENT';
export const SET_SHOW_BASE_CURRENCY = 'SET_SHOW_BASE_CURRENCY';
export const SET_FROM_MOBILE = 'SET_FROM_MOBILE';
export const SET_SETTING_FIELD = 'SET_SETTING_FIELD';
export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_FAVICON_URL = 'SET_FAVICON_URL';
export const SET_NOTIFICATION_ICON_URL = 'SET_NOTIFICATION_ICON_URL';
export const SET_IS_CURRENT_INCOMPLETE_MD = 'SET_IS_CURRENT_INCOMPLETE_MD';
export const SET_IS_INCOMPLETE_CONID_SELECTED_IN_QUICKTRADE = 'SET_IS_INCOMPLETE_CONID_SELECTED_IN_QUICKTRADE';
export const SET_PICKER_ACCOUNTS = 'SET_PICKER_ACCOUNTS';
export const ROUTE_LOADING = 'ROUTE_LOADING';
export const PRIVACY_MODE = 'PRIVACY_MODE';
export const SET_ACCOUNT_PROPERTIES = 'SET_ACCOUNT_PROPERTIES';
export const SET_AM_STATUS = 'SET_AM_STATUS';
export const SET_SHOW_IB_KEY_WIDGET = 'SET_SHOW_IB_KEY_WIDGET';
export const SET_SHOW_CRYPTO_POPOVER = 'SET_SHOW_CRYPTO_POPOVER';
export const SET_REGSNAPSHOT = 'SET_REGSNAPSHOT';
export const CLEAR_REGSNAPSHOTS = 'CLEAR_REGSNAPSHOTS';

export const TOGGLE_TEST_CRYPTO_POS = 'TOGGLE_TEST_CRYPTO_POS';

//wide screen
export const SET_WIDE_SCREEN_SELECTED_CONID = 'SET_WIDE_SCREEN_SELECTED_CONID';
export const SET_SHOW_PORTFOLIO_RIGHT_COL = 'SET_SHOW_PORTFOLIO_RIGHT_COL';
export const SET_WIDE_LAYOUT = 'SET_WIDE_LAYOUT';
